import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Translation } from 'react-i18next'

class Footer extends Component {
    render() {
        return (
            <div>
                {/* ======= Footer ======= */}
                <footer id="footer">
                    <div className="footer-top">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-3 col-md-6 footer-contact">
                                    <h3>
                                        Good Good <br /> Finance
                                    </h3>
                                </div>
                                <div className="col-lg-3 col-md-6 footer-links">
                                    <h4>Benefits</h4>
                                    <ul>
                                        <li>
                                            <i className="bx bx-chevron-right" />{' '}
                                            <Link to="/benefits/personnalized-loan">
                                                Personnalized loan
                                            </Link>
                                        </li>
                                        <li>
                                            <i className="bx bx-chevron-right" />{' '}
                                            <Link to="/benefits/instant-loan">Instant loan</Link>
                                        </li>
                                        <li>
                                            <i className="bx bx-chevron-right" />{' '}
                                            <Link to="/benefits/no-credit-check-loan">
                                                No credit check loan
                                            </Link>
                                        </li>
                                        <li>
                                            <i className="bx bx-chevron-right" />{' '}
                                            <Link to="/benefits/no-refusal-loan">
                                                No refusal loan
                                            </Link>
                                        </li>
                                        <li>
                                            <i className="bx bx-chevron-right" />{' '}
                                            <Link to="/benefits/instant-etransfer-loan">
                                                Instant E-transfer loan
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                                <div className="col-lg-3 col-md-6 footer-links">
                                    <h4>Needs</h4>
                                    <ul>
                                        <li>
                                            <i className="bx bx-chevron-right" />{' '}
                                            <Link to="/needs/no-refusal-payday-loans">
                                                No refusal payday loan
                                            </Link>
                                        </li>
                                        <li>
                                            <i className="bx bx-chevron-right" />{' '}
                                            <Link to="/needs/emergency-loan">Emergency loan</Link>
                                        </li>
                                    </ul>
                                </div>
                                <div className="col-lg-3 col-md-6 footer-links">
                                    <h4>Small loans</h4>
                                    <ul>
                                        <li>
                                            <i className="bx bx-chevron-right" />{' '}
                                            <Link to="/small-loans">Small loans</Link>
                                        </li>
                                        <li>
                                            <i className="bx bx-chevron-right" />{' '}
                                            <Link to="/small-loans/200">Small loan of 200$</Link>
                                        </li>
                                        <li>
                                            <i className="bx bx-chevron-right" />{' '}
                                            <Link to="/small-loans/300">Small loan of 300$</Link>
                                        </li>
                                    </ul>
                                </div>
                                <div class="d-none d-lg-block col-lg-3 col-md-6 footer-links"></div>
                                <div className="col-lg-3 col-md-6 footer-links">
                                    <h4>Situations</h4>
                                    <ul>
                                        <li>
                                            <i className="bx bx-chevron-right" />{' '}
                                            <Link to="/situations/bad-credit-loan">
                                                Bad credit loan
                                            </Link>
                                        </li>
                                        <li>
                                            <i className="bx bx-chevron-right" />{' '}
                                            <Link to="/situations/loan-no-job">Loan no job</Link>
                                        </li>
                                    </ul>
                                </div>
                                <div className="col-lg-3 col-md-6 footer-links">
                                    <h4>
                                        <Translation>
                                            {(t) => <span>{t('footer_title2')}</span>}
                                        </Translation>
                                    </h4>
                                    <ul>
                                        <li>
                                            <i className="bx bx-chevron-right" />
                                            <Link to="/new-lead" className="btn-learn-more">
                                                <Translation>
                                                    {(t) => <span>{t('navbar_button')}</span>}
                                                </Translation>
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                                <div className="col-lg-3 col-md-6 footer-links">
                                    <h4>
                                        <Translation>
                                            {(t) => <span>{t('footer_title3')}</span>}
                                        </Translation>
                                    </h4>
                                    <ul>
                                        <li>
                                            <i className="bx bx-chevron-right" />
                                            <Link
                                                to="/politique_confidentialite"
                                                className="btn-learn-more"
                                            >
                                                <Translation>
                                                    {(t) => <span>{t('footer_title3')}</span>}
                                                </Translation>
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="container footer-bottom clearfix">
                        <div className="copyright">
                            © Copyright{' '}
                            <strong>
                                <span>GoodGoodFinance</span>
                            </strong>
                            .{' '}
                            <Translation>{(t) => <span>{t('footer_copyright')}</span>}</Translation>
                        </div>
                        <div className="credits">
                            <a href="#">
                                <Translation>
                                    {(t) => <span>{t('navbar_title1')}</span>}
                                </Translation>{' '}
                            </a>
                        </div>
                    </div>
                </footer>
                {/* End Footer */}
            </div>
        )
    }
}
export default Footer
